<template>
  <!-- MBR054 Attendance — same Activity layout as MyTransactions -->
  <div class="page-header align-items-start min-vh-screen mbr-activity">
    <span class="mask bg-white"></span>
    <div class="container p-0">
      <header class="mbr-activity__bar">
        <div class="mbr-activity__head">
          <h1 class="mbr-activity__title">{{ $t('admissions.title') }}</h1>
          <FilterToolbarTransaction
            :filterArrCashbackEarnStatus="filterArrCashbackEarnStatus"
            :filterCashbackTimeSelected="filterCashbackTimeSelected"
            :filterArrStore="filterArrStore"
            v-if="isFirstLoadDone && typeSelected == 1"
          />
        </div>
      </header>

      <main v-if="isFirstLoadDone" class="mbr-activity__body">
        <section class="mbr-activity__card">
          <div class="mbr-activity__card-row">
            <div class="mbr-activity__card-main">
              <span class="mbr-activity__label">{{ $t('home.home_match_attended') }}</span>
              <div class="mbr-activity__card-value">{{ merchantMember.total_visit }}</div>
            </div>
            <div class="mbr-activity__tier">
              <img
                v-if="merchantMember.current_tier_icon"
                :src="merchantMember.current_tier_icon"
                class="mbr-activity__tier-icon"
                alt=""
              />
              <span v-if="merchantMember.current_tier_name" class="mbr-activity__tier-name">{{ merchantMember.current_tier_name }}</span>
            </div>
          </div>
          <material-progress :percentage="merchantMember.level_percentage" variant="fill" class="mbr-activity__progress" />
          <p v-if="merchantMember.level_note" class="mbr-activity__note">{{ merchantMember.level_note }}</p>
        </section>

        <div class="mbr-activity__month-row">
          <!-- teleportCenter: anchored under the pill, the menu's Select button sat behind MbrBottomNav -->
          <Datepicker
            v-model="timeSelect"
            monthPicker
            :locale="dateLocale()"
            teleportCenter
            class="mbr-activity__picker"
            menuClassName="mbr-dp-menu"
            :format="format"
            :selectText="$t('admissions.select')"
            :cancelText="$t('common.cancel')"
          >
            <template #trigger>
              <button type="button" class="mbr-activity__month">
                <span>{{ monthLabel }}</span>
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m6 9 6 6 6-6" /></svg>
              </button>
            </template>
          </Datepicker>
          <span v-if="isLoadDone" class="mbr-activity__count">{{ $t(visitCount == 1 ? 'admissions.visit_one' : 'admissions.visit_other', { n: visitCount }) }}</span>
        </div>

        <section v-for="group in dayGroups" :key="group.key" class="mbr-activity__group">
          <h2 class="mbr-activity__day">{{ group.label }}</h2>
          <article v-for="(value, index2) in group.rows" :key="group.key + '_' + index2" class="mbr-activity__row">
            <span class="mbr-activity__icon mbr-activity__icon--in" aria-hidden="true">
              <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg>
            </span>
            <div class="mbr-activity__row-main">
              <div class="mbr-activity__row-title">{{ value.transaction_label ?? "" }}</div>
              <div class="mbr-activity__row-time">{{ timeOf(value.createdAt) }}</div>
              <div v-if="value.receipt_no" class="mbr-activity__row-meta">{{ $t('admissions.receipt_no', { no: value.receipt_no }) }}</div>
            </div>
          </article>
        </section>
        <p v-if="isLoadDone && !visitCount" class="mbr-activity__empty">{{ $t('admissions.no_items') }}</p>
      </main>
    </div>
    <FilterTransaction
      :filterCashbackType="filterCashbackType"
      :filterArrCashbackEarnStatus="filterArrCashbackEarnStatus"
      :filterStore="filterStore"
      :filterArrStore="filterArrStore"
      :filterCashbackTimeSelected="filterCashbackTimeSelected"
      :filterCashbackTime="filterCashbackTime"
      :filterData="filterData"
      :resetData="resetData"
    />
    <material-loading :active="loaderActive" />
    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <QrcodeMember />
    <MbrBottomNav />
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MemberService from "../services/member.service";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialProgress from "@/components/MaterialProgress.vue";
import FilterTransaction from "@/components/FilterTransaction.vue";
import FilterToolbarTransaction from "@/components/FilterToolbarTransaction.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import $ from "jquery";
import { getMerchantCode } from "@/config/utils";
import { isEnglish, formatDate as formatLocaleDate, dateLocale } from "@/i18n";
import QrcodeMember from "@/components/QrcodeMember.vue";
import MbrBottomNav from "@/components/MbrBottomNav.vue";
import { errorMessage } from "@/utils/errorMessage";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default {
  name: "my-admissions",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialProgress,
    FilterTransaction,
    FilterToolbarTransaction,
    Datepicker,
    QrcodeMember,
    MbrBottomNav,
  },
  data() {
    return {
      isFirstLoadDone: false,
      isLoadDone: false,
      listTransaction: [],
      merchantCode: "",
      loaderActive: false,
      typeSelected: 1,
      filterArrCashbackEarnStatus: [],
      filterArrStore: [],
      filterCashbackTimeSelected: null,
      timeSelect: {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
      },
      params: {
        filter_cashback_earn_status: [],
        filter_store: [],
        filter_cashback_time: null,
      },
      merchantMember: {},
    };
  },
  // draws its own header like the design: hide the top navbar, and keep the
  // sidenav as an off-screen drawer (same as MyTransactions)
  beforeMount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.add("mbr-sidenav-overlay");
    app.classList.remove("g-sidenav-pinned");
  },
  beforeUnmount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.remove("mbr-sidenav-overlay");
    if (window.innerWidth > 1200) {
      app.classList.add("g-sidenav-pinned");
    }
  },
  async mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
    await this.getMyTransactions();
    this.isFirstLoadDone = true;
  },
  computed: {
    monthLabel() {
      const { year, month } = this.timeSelect || {};
      if (year === undefined || month === undefined) {
        return "";
      }
      if (!isEnglish()) {
        return formatLocaleDate(new Date(year, month, 1), { month: "long", year: "numeric" });
      }
      return `${MONTHS[month]} ${year}`;
    },

    // list_transaction is { "September, 2026": [rows] }; createdAt is "d/m/Y h:i A"
    dayGroups() {
      const groups = [];
      Object.keys(this.listTransaction || {}).forEach((monthKey) => {
        (this.listTransaction[monthKey] || []).forEach((row) => {
          const date = String(row.createdAt || "").split(" ")[0];
          let group = groups.find((item) => item.key === date);
          if (!group) {
            group = { key: date, label: this.dayLabel(date) || monthKey, rows: [] };
            groups.push(group);
          }
          group.rows.push(row);
        });
      });
      return groups;
    },

    visitCount() {
      return this.dayGroups.reduce((total, group) => total + group.rows.length, 0);
    },
  },
  methods: {
    dateLocale,
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig", "toggleNavbarOnly"]),
    ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),

    async getMyTransactions(type, paramsFilter = {}) {
      this.isLoadDone = false;
      this.listTransaction = [];
      this.showLoader();

      await MemberService.getAdmissionsTransactions(
        type,
        this.timeSelect,
        paramsFilter
      ).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.listTransaction = response.data.data.list_transaction;
            this.merchantMember = response.data.data.merchant_member;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    filterCashbackType(idStatus) {
      this.filterArrCashbackEarnStatus = idStatus;
    },

    filterCashbackTime(value) {
      this.filterCashbackTimeSelected = value;
    },

    filterStore(value) {
      const index = this.filterArrStore.indexOf(value);
      if (index > -1) {
        this.filterArrStore.splice(index, 1);
      } else {
        this.filterArrStore.push(value);
      }
    },

    filterData() {
      $(".btn-close").click();
      $(".x-close").click();
      this.params.filter_cashback_earn_status = this.filterArrCashbackEarnStatus;
      this.params.filter_store = this.filterArrStore;
      this.params.filter_cashback_time = this.filterCashbackTimeSelected;
      this.getMyTransactions(1, this.params);
    },
    resetData() {
      this.filterArrCashbackEarnStatus = [];
      this.filterArrStore = [];
      this.filterCashbackTimeSelected = null;
      this.filterData();
    },

    // "14/09/2026" -> "14 Sep 2026"
    dayLabel(date) {
      const [day, month, year] = String(date).split("/");
      const name = MONTHS[Number(month) - 1];
      if (!isEnglish()) {
        return day && name && year
          ? formatLocaleDate(new Date(year, Number(month) - 1, day), { day: "numeric", month: "short", year: "numeric" })
          : "";
      }
      return day && name && year ? `${day} ${name.slice(0, 3)} ${year}` : "";
    },

    // "14/09/2026 03:24 PM" -> "03:24 PM"
    timeOf(createdAt) {
      return String(createdAt || "").split(" ").slice(1).join(" ");
    },

    format(date) {
      const getMonth = String(date.getMonth() + 1);
      const month = getMonth.padStart(2, "0");
      const year = String(date.getFullYear());
      return `${month}-${year}`;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    timeSelect(val) {
      if (val) {
        if (this.typeSelected == 1) {
          this.getMyTransactions(this.typeSelected, this.params);
        } else {
          this.getMyTransactions(this.typeSelected);
        }
      }
    },
  },
};
</script>

<style scoped>
/* MBR054 Attendance — same shell and list as MyTransactions (MBR048/MBR050/MBR051) */

/* Material Dashboard's `.page-header { overflow: hidden }` would stop the header sticking */
.mbr-activity.page-header {
  overflow: visible;
  overflow-x: clip;
  /* room for the fixed MbrBottomNav */
  padding-bottom: 120px;
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

/* custom.css still carries the legacy `* { font-family: Poppins }`;
   :where() keeps this at one attribute's specificity so the class rules below win */
.mbr-activity :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-activity .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

/* mobile column, like Home and Rewards */
.mbr-activity .container {
  max-width: 440px;
  margin: 0 auto;
}

.mbr-activity__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 32px 20px 12px;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-activity__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 40px;
  margin-bottom: 16px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-activity__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 28px;
  font-weight: 800;
  line-height: 36px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-strong);
}

/* MBR050 tier / donation cards */
.mbr-activity__card {
  margin-bottom: 16px;
  padding: 18px 20px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-xl);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-activity__card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.mbr-activity__card-main {
  min-width: 0;
}

.mbr-activity__label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-activity__card-value {
  margin-top: 2px;
  font-family: var(--mbr-font-headline);
  font-size: 22px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.015em;
  color: var(--mbr-color-primary);
  overflow-wrap: anywhere;
}

.mbr-activity__tier {
  display: flex;
  flex: none;
  align-items: center;
  gap: 8px;
  max-width: 50%;
}

.mbr-activity__tier-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: var(--mbr-radius-full);
}

.mbr-activity__tier-name {
  padding: 4px 10px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mbr-activity__progress {
  margin-top: 14px;
}

.mbr-activity__note {
  margin: 10px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}
/* MBR051 month picker + rows */
.mbr-activity__body {
  padding: 8px 20px 0;
}

.mbr-activity__month-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 4px;
}

.mbr-activity__picker {
  width: auto;
}

.mbr-activity__month {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.7);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-primary);
}

.mbr-activity__month svg {
  width: 14px;
  height: 14px;
}

.mbr-activity__month:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-activity__count {
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  color: rgba(var(--mbr-color-ink-secondary-rgb), 0.7);
}

.mbr-activity__group {
  margin-top: 16px;
}

/* a div-sized label: custom.css forces mobile h2 to 22px !important */
.mbr-activity .mbr-activity__day {
  margin: 0 0 10px;
  font-family: var(--mbr-font-body);
  font-size: 11px !important;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-activity__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-lg);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-activity__row + .mbr-activity__row {
  margin-top: 10px;
}

.mbr-activity__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  width: 44px;
  height: 44px;
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-activity__icon svg {
  width: 20px;
  height: 20px;
}

.mbr-activity__icon--in {
  background: var(--mbr-color-peach);
}

.mbr-activity__icon--out {
  background: var(--mbr-color-palepink);
}

.mbr-activity__icon--voucher {
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.6);
}

/* basis 0: with flex-wrap on the row, an auto basis pushed the amount onto its own line */
.mbr-activity__row-main {
  flex: 1 1 0%;
  min-width: 0;
}

.mbr-activity__row-title {
  font-family: var(--mbr-font-headline);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-ink-strong);
  overflow-wrap: anywhere;
}

.mbr-activity__row-time {
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  color: rgba(var(--mbr-color-ink-secondary-rgb), 0.7);
}

.mbr-activity__row-meta {
  margin-top: 2px;
  font-size: 10px;
  line-height: 14px;
  color: rgba(var(--mbr-color-ink-secondary-rgb), 0.6);
  overflow-wrap: anywhere;
}

/* full width under the icon/label/amount line, indented past the icon */
.mbr-activity__row-earn {
  flex: 1 0 calc(100% - 56px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: -4px 0 0 56px;
  padding-top: 8px;
  border-top: 1px dashed rgba(var(--mbr-color-outline-rgb), 0.7);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-activity__status {
  flex: none;
  padding: 2px 8px;
  border-radius: var(--mbr-radius-full);
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
}

.mbr-activity__status--ok {
  background: rgba(var(--mbr-color-positive-rgb), 0.1);
  color: var(--mbr-color-positive);
}

.mbr-activity__status--wait {
  background: var(--mbr-color-peach);
  color: var(--mbr-color-primary);
}

.mbr-activity__amount {
  flex: none;
  align-self: flex-start;
  padding-top: 2px;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: right;
  white-space: nowrap;
}

.mbr-activity__amount--in {
  color: var(--mbr-color-positive);
}

.mbr-activity__amount--out {
  color: var(--mbr-color-primary);
}

.mbr-activity__empty {
  margin: 32px 0 0;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: var(--mbr-color-ink-muted);
}
</style>
